export default "__VITE_ASSET__D9Ni_Wb8__"